const AfterAHundredYears = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>After a hundred years</h2>
            <h4>Emily Dickinson</h4>
            <p>After a hundred years<br/>
            Nobody knows the place<br/>
            Agony, that enacted there<br/>
            Motionless as peace<br/>
            <br/>
            Weeds triumphant ranged<br/>
            Strangers strolled and spelled<br/>
            At the lone orthography<br/>
            Of the elder dead<br/>
            <br/>
            Winds of summer fields<br/>
            Recollect the way<br/>
            Instinct picking up the key<br/>
            Dropped by memory<br/>
            <br/>
            </p>
        </div>
    );
}
export default AfterAHundredYears;